import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsSvgIcon } from '../../shared/CpsSvgIcon';
import { CpsGridCell } from './CpsGridCell';

interface RemoveCellProps extends GridCustomCellProps {
  onClick: () => void;
}

export const RemoveCell: React.FC<RemoveCellProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      customStyle={{ padding: 0 }}
      title={translate('custom.common.remove')}
    >
      <CpsSvgIcon customIcon="removeIcon" className="removeIcon" onClick={props.onClick} role="button" />
    </CpsGridCell>
  );
};
